import React from "react";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WrongUserAnimationBlock = () => {
  return (
    <span className="italic bg-white shadow-md inline-block py-0.5 px-2 leading-none text-center align-baseline rounded-full">
      <FontAwesomeIcon icon={faTimes} /> Cannot enter another person&apos;s
      animation
    </span>
  );
};

export { WrongUserAnimationBlock };
